
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","viewBox":"0 0 21 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.94 1.42L1.713.019A1.488 1.488 0 00.52.346 1.5 1.5 0 000 1.47v17.69c0 .461.378.839.84.839h2.728v-4.408c0-.814.655-1.469 1.47-1.469h2.098c.815 0 1.47.655 1.47 1.47V20h3.568V2.873a1.47 1.47 0 00-1.234-1.452zM4.618 12.235h-1.26a.63.63 0 010-1.26h1.26a.63.63 0 010 1.26zm0-2.519h-1.26a.63.63 0 010-1.259h1.26a.63.63 0 010 1.26zm0-2.518h-1.26a.63.63 0 010-1.26h1.26a.63.63 0 010 1.26zm0-2.519h-1.26a.63.63 0 010-1.26h1.26a.63.63 0 010 1.26zm4.197 7.556H7.556a.63.63 0 010-1.26h1.26a.63.63 0 010 1.26zm0-2.519H7.556a.63.63 0 010-1.259h1.26a.63.63 0 010 1.26zm0-2.518H7.556a.63.63 0 010-1.26h1.26a.63.63 0 010 1.26zm0-2.519H7.556a.63.63 0 010-1.26h1.26a.63.63 0 010 1.26zM18.99 8.953l-5.977-1.252V20h5.667c.81 0 1.47-.66 1.47-1.47v-8.14c0-.694-.473-1.284-1.16-1.436zm-1.989 8.528h-1.26a.63.63 0 010-1.26h1.26a.63.63 0 010 1.26zm0-2.518h-1.26a.63.63 0 010-1.26h1.26a.63.63 0 010 1.26zm0-2.52h-1.26a.63.63 0 010-1.258h1.26a.63.63 0 010 1.259z"}})])
          )
        }
      }
    